import * as React from "react"
import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"

const DynamicActionBar = React.forwardRef(({ actions, className, ...props }, ref) => {
  const [activeIndex, setActiveIndex] = useState(null)
  const activeAction = activeIndex !== null ? actions?.[activeIndex] : null
  const BUTTON_BAR_HEIGHT = 56

  const containerAnimate = activeAction
    ? { width: activeAction.dimensions.width, height: activeAction.dimensions.height + BUTTON_BAR_HEIGHT }
    : { width: 410, height: BUTTON_BAR_HEIGHT }

  const transition = { type: "spring", stiffness: 400, damping: 35 }

    return (
    <div ref={ref} className={`relative ${className || ""}`} onMouseLeave={() => setActiveIndex(null)} {...props}>
            <style>{`
        .dynamic-action-scroll {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .dynamic-action-scroll::-webkit-scrollbar {
          display: none;
        }
        @media (hover: hover) and (pointer: fine) {
          .dynamic-action-scroll {
            scrollbar-width: thin;
            scrollbar-color: hsl(var(--border)) transparent;
          }
          .dynamic-action-scroll::-webkit-scrollbar {
            display: block;
            height: 4px;
          }
          .dynamic-action-scroll::-webkit-scrollbar-track {
            background: transparent;
          }
          .dynamic-action-scroll::-webkit-scrollbar-thumb {
            background-color: hsl(var(--border));
            border-radius: 9999px;
            transition: background-color 0.2s ease;
          }
          .dynamic-action-scroll::-webkit-scrollbar-thumb:hover {
            background-color: hsl(var(--muted-foreground) / 0.5);
          }
        }
      `}</style>
      <motion.div
        className="flex flex-col overflow-hidden rounded-2xl bg-card border border-border shadow-sm max-w-full"
        animate={containerAnimate}
        transition={transition}
        initial={{ width: 410, height: BUTTON_BAR_HEIGHT }}
      >
        <div className="flex-grow overflow-hidden">
          <AnimatePresence>
            {activeAction && (
              <motion.div
                className="w-full"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2, delay: 0.1 }}
              >
                {activeAction.content}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
                        <div className="dynamic-action-scroll flex flex-shrink-0 items-center justify-center gap-1 px-1 sm:gap-2 sm:px-2 overflow-x-auto" style={{ height: `${BUTTON_BAR_HEIGHT}px` }}>
          {actions?.map((action, index) => {
            const Icon = action.icon
            return (
                                          <button
                key={action.id}
                onMouseEnter={() => setActiveIndex(index)}
                onClick={() => setActiveIndex((current) => (current === index ? null : index))}
                aria-label={action.label}
                title={action.label}
                className="flex items-center justify-center rounded-2xl py-3 px-2.5 sm:px-4 text-foreground transition-colors duration-300 hover:bg-foreground hover:text-background shrink-0"
              >
                <Icon className="size-5" />
              </button>
            )
          })}
        </div>
      </motion.div>
    </div>
  )
})
DynamicActionBar.displayName = "DynamicActionBar"

export default DynamicActionBar